var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tabs"},_vm._l((_vm.choices),function(choice,index){return _c('div',{key:index,class:['tab', _vm.value === choice.key && 'tab--active'],on:{"click":function($event){return _vm.select(choice.key)}}},[_vm._v(" "+_vm._s(choice.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }